/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgLocateNodeLeft = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        clipRule="evenodd"
        d="M12 4a5 5 0 1 0 0 10 5 5 0 0 0 0-10zM5 9a7 7 0 1 1 12.606 4.192l4.101 4.1-1.414 1.415-4.1-4.1A7 7 0 0 1 5 9zm.785 11 .787.797-1.422 1.406L1.985 19l3.165-3.203 1.422 1.406-.787.797h4.606v2z"
        fill="currentcolor"
        fillRule="evenodd"
      />
    </g>
  </Icon>
);
export { SvgLocateNodeLeft as LocateNodeLeft };
